import { computed, reactive } from 'vue'
import { DEFAULT_THEME, THEME_STORAGE_KEY, normalizeTheme } from '~/utils/theme-document'

/** @deprecated 请从 `~/utils/theme-document` 导入 `THEME_STORAGE_KEY` */
export const LIP_DASHBOARD_THEME_STORAGE_KEY = THEME_STORAGE_KEY

/**
 * Light/dark 主题。`html.dark` 由 `plugins/theme-html.ts` + 首屏内联脚本同步；
 * 此处读写与 cookie 绑定的同一 ref，供布局/组件切换主题。
 */
export function useThemeMode(options = {}) {
  const {
    storageKey = THEME_STORAGE_KEY,
    defaultTheme = DEFAULT_THEME,
    syncHtml = true,
  } = options

  const theme = useCookie(storageKey, {
    default: () => defaultTheme,
    watch: true,
  })

  const wrapperDarkClass = computed(() =>
    syncHtml ? {} : { dark: theme.value === 'dark' },
  )

  function setTheme(mode) {
    theme.value = normalizeTheme(mode, defaultTheme)
  }

  function toggleTheme() {
    theme.value = theme.value === 'dark' ? 'light' : 'dark'
  }

  return reactive({
    theme,
    wrapperDarkClass,
    setTheme,
    toggleTheme,
  })
}
